/**
 * Checks if a WebSocket message contains an error that should prevent setQueryData calls
 * @param data - The message data from WebSocket
 * @returns true if the message contains an error, false otherwise
 */
export const isWebSocketErrorMessage = (data: any): boolean => {
  // Check if data is an error object
  if (data && typeof data === 'object' && data.error) {
    return true
  }

  // Check if data is a string that contains error information
  if (
    typeof data === 'string' &&
    (data.includes('ERROR:') ||
      data.includes('SQLSTATE') ||
      data.includes('relation') ||
      data.includes('does not exist'))
  ) {
    return true
  }

  return false
}
